import type { Faq } from "@components/Faq.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getFaqsIndustries(tenant: Tenant): Faq[] {
	return [
		{
			question: "V seznamu výše jsem nenašel svůj obor. Pomůžete mi i tak?",
			answer:
				"Ano, výše uvádíme odvětví, kterým dodáváme IT řešení pravidelně. Nemáme nicméně problém proniknout i do dalších oborů.",
		},
		{
			question: "V čem se váš přístup liší od jiných firem, které vyvíjí webové a mobilní aplikace?",
			answer:
				"Za prvé děláme vývoj na zakázku (většinou pomocí tzv. agilního vývoje), nenabízíme tedy krabicová řešení. Za druhé vyvíjíme primárně na cloudu, čímž klientům šetříme až desítky tisíc Kč za dedikované servery.",
		},
		{
			question: "Děláte všechno interně, nebo spolupracujete s externisty? ",
			answer:
				"Za mnoho let v oboru jsme si vybudovali síť externistů, kteří nám pomáhají pokrýt oblasti jako marketing, grafiku, účetnictví nebo logistiku. Pro práci IT projektech ale využíváme primárně interní specialisty.",
		},
		{
			question: "Dříve jsme ve firmě měli problémy se stabilitou systémů. Dokáže tomu předcházet?",
			answer:
				"Ano, systémy, které zákazníkům dodáváme, fungují 100% bez výpadků, stabilita je jednou z našich hlavních priorit.",
		},
	];
}
